import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape, ugcPrivateNoteShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { UGC_CONTENT_TYPES } from '@bibliocommons/constants-ugc';
import { supportsUGCContentType } from '@bibliocommons/utils-ugc';

import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import PrivateNoteDisplay from '../../../shared/UGC/PrivateNoteDisplay';

import './PrivateNoteInfo.scss';

export default class ShelfListItemPrivateNoteInfo extends BcReactComponent {
  render() {
    const {
      bib,
      item,
      owner,
      currentLibrary,
      localBranch,
      ownerPrivateNoteForBib,
      privateNotesTransactions,
      shelfTransactions,
      privateNotesActions,
      shelfActions
    } = this.props;

    if (ownerPrivateNoteForBib && supportsUGCContentType(UGC_CONTENT_TYPES.PRIVATE_NOTE, currentLibrary, localBranch)) {
      return (
        <div className="cp-shelf-list-item-private-note-info">
          <DisplayHeading><FormattedMessage id="ugc_private_note_display_label" /></DisplayHeading>
          <PrivateNoteDisplay
            bib={bib}
            shelfItem={item}
            owner={owner}
            privateNote={ownerPrivateNoteForBib}
            privateNotesTransactions={privateNotesTransactions}
            shelfTransactions={shelfTransactions}
            privateNotesActions={privateNotesActions}
            shelfActions={shelfActions} />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemPrivateNoteInfo.propTypes = {
  bib: bibShape.isRequired,
  currentLibrary: ImmutablePropTypes.map.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  localBranch: PropTypes.string,
  ownerPrivateNoteForBib: ugcPrivateNoteShape,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/PrivateNoteInfo/PrivateNoteInfo.jsx